import { ResizeHandle } from 'components/shared/WithSplitterNext/ResizeHandle';
import { FC, ReactNode, useCallback, useRef, useState } from 'react';
import { ImperativePanelGroupHandle, ImperativePanelHandle, Panel, PanelGroup } from 'react-resizable-panels';

export interface WithSplitterProps {
  maxSecondarySize?: number;
  primaryPanel: ReactNode;
  secondaryPanel: ReactNode;
  badgeContent?: ReactNode;
}

export const WithSplitterNext: FC<WithSplitterProps> = ({
  maxSecondarySize = 70,
  primaryPanel,
  secondaryPanel,
  badgeContent,
}) => {
  const panelGroupRef = useRef<ImperativePanelGroupHandle>(null);
  const secondaryPanelRef = useRef<ImperativePanelHandle>(null);
  const [isCollapsed, setCollapsed] = useState(true);

  const handleToggle = useCallback(() => {
    setCollapsed(prev => {
      panelGroupRef.current?.setLayout(prev ? [100 - maxSecondarySize, maxSecondarySize] : [100, 0]);
      return !prev;
    });
  }, [maxSecondarySize]);

  const handleDragging = useCallback((isDragging: boolean) => {
    if (!isDragging) {
      setCollapsed(secondaryPanelRef.current?.getSize() === 0);
    }
  }, []);

  return (
    <PanelGroup direction="vertical" ref={panelGroupRef}>
      <Panel style={{ zIndex: 2 }} defaultSize={100} maxSize={100}>
        {primaryPanel}
      </Panel>
      <ResizeHandle e2e="central-station-orders-basket-badge" onDragging={handleDragging}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="icon icon-md icon-outlined mx-1" style={{ cursor: 'pointer' }} onClick={handleToggle}>
            {isCollapsed ? 'expand_less' : 'expand_more'}
          </div>
          <div style={{ cursor: 'pointer' }} onClick={handleToggle}>
            {badgeContent}
          </div>
          <div className="icon icon-md icon-outlined mx-1 text-muted" style={{ cursor: 'ns-resize', opacity: 0.5 }}>
            drag_handle
          </div>
        </div>
      </ResizeHandle>
      <Panel ref={secondaryPanelRef} defaultSize={0} maxSize={70}>
        {secondaryPanel}
      </Panel>
    </PanelGroup>
  );
};
